<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.34757 29.0804C2.29228 29.1651 2.26078 29.2631 2.25639 29.3641C2.252 29.4651 2.27487 29.5655 2.32261 29.6547C2.37035 29.7438 2.44119 29.8185 2.52772 29.8709C2.61425 29.9232 2.71327 29.9513 2.8144 29.9523H33.1876C33.3366 29.9518 33.4794 29.8924 33.5848 29.787C33.6902 29.6816 33.7496 29.5388 33.75 29.3898V22.3589H6.83041L2.34757 29.0804Z"
      fill="#5EB24A"
    />
    <path
      d="M12.6406 21.2338H33.7501V14.7656H16.955L12.6406 21.2338Z"
      fill="#FFE400"
    />
    <path
      d="M33.1877 6.04744H28.1255C28.0328 6.04766 27.9416 6.07091 27.8601 6.11509C27.7786 6.15927 27.7094 6.22301 27.6586 6.30056L22.7651 13.6407H33.7501V6.60989C33.7497 6.46086 33.6903 6.31805 33.5849 6.21266C33.4795 6.10728 33.3367 6.04788 33.1877 6.04744Z"
      fill="#5EB24A"
    />
  </svg>
</template>

<script lang="ts">
export default {};
</script>
